// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BeDepentFilledSvg from "@fishx/icons-svg/es/asn/BeDepentFilled";
import FishxIcon from '../components/FishxIcon';

var BeDepentFilled = function BeDepentFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BeDepentFilledSvg
  }));
};

BeDepentFilled.displayName = 'BeDepentFilled';
export default React.forwardRef(BeDepentFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BeDepentFilled.js
// module id = 2064
// module chunks = 0